import { render, staticRenderFns } from "./CrudSlotsEditor.vue?vue&type=template&id=5be0e83c&scoped=true&"
import script from "./CrudSlotsEditor.vue?vue&type=script&lang=js&"
export * from "./CrudSlotsEditor.vue?vue&type=script&lang=js&"
import style0 from "./CrudSlotsEditor.vue?vue&type=style&index=0&id=5be0e83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0e83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSelect,VSimpleTable})
